import workbenchStore from '@/views/workbenchCanvas/store'
import {SET_TRIGGERED_ONCE} from './WorkbenchActions'

export const SET_DAY_PARTS = 'SET_DAY_PARTS'
export const SET_DATA_SOURCES = 'SET_DATA_SOURCES'
export const SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE'
export const SET_HISTORICAL_VIEWERSHIP = 'SET_HISTORICAL_VIEWERSHIP'
export const SET_UNIVERSE = 'SET_UNIVERSE'
export const SET_PREVIEW_TABLE_OPEN = 'SET_PREVIEW_TABLE_OPEN'
export const SET_AGE_DISTRIBUTION = 'SET_AGE_DISTRIBUTION'
export const SET_INCOME_DISTRIBUTION = 'SET_INCOME_DISTRIBUTION'
export const SHOW_DROPPED_ATTRIBUTES_MODEL = 'SHOW_DROPPED_ATTRIBUTES_MODEL'

export default {
  ...workbenchStore.mutations,
  [SET_DAY_PARTS] (state, value) {
    state.dayParts = value
  },
  [SET_DATA_SOURCES] (state, value) {
    state.dataSources = value
  },
  [SET_AUDIENCE_SIZE] (state, value) {
    state.audienceSize = value || 0
  },
  [SET_UNIVERSE] (state, value) {
    state.universe = value
  },
  [SET_HISTORICAL_VIEWERSHIP] (state, value) {
    state.historicalViewership = value
  },
  [SET_PREVIEW_TABLE_OPEN] (state, bool) {
    state.previewTableOpen = bool
  },
  [SET_AGE_DISTRIBUTION] (state, data) {
    data.sort((a, b) => a.age - b.age)
    state.ageDistribution = data.map(d => {
      d.value = Math.floor(d.value)
      return d
    })
  },
  [SET_INCOME_DISTRIBUTION] (state, data) {
    data = data.filter(d => d !== null).map(d => {
      d.startIncome = Math.floor(Number(d.startIncome))
      d.finishIncome = Math.floor(Number(d.finishIncome))
      d.value = Math.floor(d.value)
      return d
    })
    data.sort((a, b) => a.startIncome - b.startIncome)
    state.incomeDistribution = data
  },
  [SHOW_DROPPED_ATTRIBUTES_MODEL] (state) {
    if (state.showDroppedAttributeModel) {
      state.showDroppedAttributeModel = state.showDroppedAttributeModel + 1
    } else {
      state.showDroppedAttributeModel = 1
    }
  },
  [SET_TRIGGERED_ONCE] (state) {
    state.triggeredOnce = true
  }
}



// WEBPACK FOOTER //
// ./src/app/views/workbench/LAS/store/mutations.js